import { Typography } from "@material-ui/core";
import { modalStressTextColor, modalTextColor } from "../lib/Color";
import { ModeType } from "./hooks/AssetSettingModalType";

type Props = {
    mode: ModeType;
}

const SettingModeLabel: React.FC<Props> = ({ mode }) => {
    return (
        <>
            <Typography variant="h5" align="center" >
                <span style={{ color: mode === "Hero" ? modalStressTextColor : modalTextColor }}>Select Heroes </span>
                <span style={{ color: modalTextColor }}>{"> "}</span>
                <span style={{ color: mode === "ExtensionLeft" || mode === "ExtensionRight" ? modalStressTextColor : modalTextColor }}>Select Extension </span>
                <span style={{ color: modalTextColor }}>{"> "}</span>
                <span style={{ color: mode === "ArtSkill" ? modalStressTextColor : modalTextColor }}>Select Art Skill </span>
            </Typography>
        </>
    );
}

export default SettingModeLabel;